import type { FunctionComponent } from "react";
import { TextField } from "../../form/TextField";
import { useStaticDataAtomValue } from "../../staticDataAtom";

export const PostalCodeInput: FunctionComponent = () => {
    const {
        cmsData: {
            location: { zipPostalCode },
        },
    } = useStaticDataAtomValue();

    return <TextField label={zipPostalCode} field="postalCode" dataElementName="zip-postal-code" />;
};
